import { Component, ViewChild } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { NgSelectComponent } from '@ng-select/ng-select';

@Component({
  selector: 'irembogov-custom-multiselect-checkbox',
  templateUrl: './custom-multiselect-checkbox.component.html',
  styleUrls: ['./custom-multiselect-checkbox.component.scss'],
})
export class CustomMultiselectCheckboxComponent extends FieldType<FieldTypeConfig> {
  @ViewChild(NgSelectComponent) ngSelect!: NgSelectComponent;

  // Track if dropdown is open to help with styling
  isOpen = false;

  onToggle(isOpen: boolean): void {
    this.isOpen = isOpen;
  }

  // Getter to handle options properly - renamed to avoid conflict
  get selectOptions(): any[] {
    const options = this.props['options'];
    if (Array.isArray(options)) {
      return options;
    }
    return [];
  }

  // Helper method to toggle an item's selection
  toggleSelection(item: any, itemContext: any): void {
    // Get currently selected values
    const currentValue = this.formControl.value || [];
    const bindValue = this.props['bindValue'] || 'value';
    const itemValue = typeof item === 'object' ? item[bindValue] : item;

    // Check if item is already selected
    const isSelected = Array.isArray(currentValue)
      ? currentValue.includes(itemValue)
      : currentValue === itemValue;

    // Toggle selection
    let newValue: any[];
    if (isSelected) {
      // Remove item
      newValue = Array.isArray(currentValue)
        ? currentValue.filter(v => v !== itemValue)
        : [];
    } else {
      // Add item
      newValue = Array.isArray(currentValue)
        ? [...currentValue, itemValue]
        : [itemValue];
    }

    // Update form control
    this.formControl.setValue(newValue);

    // Manually trigger change detection if needed
    setTimeout(() => {
      // Keep dropdown open - this is useful to prevent it from closing after selection
      if (this.isOpen && this.ngSelect) {
        this.ngSelect.open();
      }
    }, 0);
  }
}
